import { connect } from 'react-redux';
import Cart from '../../../../shared/scripts/components/Cart/Cart';
import { initializeAddToCart } from '../../actions/cart/add';
import { initializeRemoveFromCart } from '../../actions/cart/remove';
import { initializeUpdateCart } from '../../actions/cart/update';
import { fetchCurrentCart } from '../../actions/cart/get';
import { isEmpty } from '../../../../shared/scripts/util/isEmpty';

const mapStateToProps = state => {
    const { cart } = state.shoppingCart.get;
    const lineItems = isEmpty(cart) ? [] : cart.items;

    return {
        ...state,
        lineItems
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addToCart: (data, title) => dispatch(initializeAddToCart(data, title)),
        removeFromCart: data => dispatch(initializeRemoveFromCart(data)),
        getCurrentCart: () => dispatch(fetchCurrentCart()),
        updateCart: data => dispatch(initializeUpdateCart(data)),
    };
};

/**
 * Connects the component to the Redux store
 * @returns {*}
 * @constructor
 */
const CartContainer = () => {
    return connect(mapStateToProps, mapDispatchToProps)(Cart);
};

export default CartContainer;
